module.exports = __webpack_public_path__ + "img/car-program.5ca6ed50.png";